import { Chip } from '@mui/material';
import { TournamentBracketMatchGameStatus, TournamentStatus } from '@okletsplay/core';
import classNames from 'classnames';
import {
  BRACKET_STATUS_LABEL,
  CANCELED_TOURNAMENT_BRACKET_STATUS_LABEL,
} from 'modules/bracket/constants';
import React, { FC, useMemo } from 'react';
import { useStyles } from './BracketSeedStatus.styles';

interface BracketSeedStatusProps {
  matchStatus: TournamentBracketMatchGameStatus;
  tournamentStatus: TournamentStatus;
}

const DISABLED_STATUSES = [TournamentBracketMatchGameStatus.Locked];

export const BracketSeedStatus: FC<BracketSeedStatusProps> = ({
  matchStatus,
  tournamentStatus,
}) => {
  const { classes } = useStyles();

  const isCanceledTournament = useMemo(
    () => tournamentStatus === TournamentStatus.Canceled,
    [tournamentStatus]
  );

  const statuses = useMemo(
    () => (isCanceledTournament ? CANCELED_TOURNAMENT_BRACKET_STATUS_LABEL : BRACKET_STATUS_LABEL),
    [isCanceledTournament]
  );

  if (!matchStatus || DISABLED_STATUSES?.includes(matchStatus)) {
    return null;
  }

  return (
    <Chip
      className={classNames(classes.root, classes[matchStatus], {
        canceled: isCanceledTournament,
      })}
      label={statuses[matchStatus]}
    />
  );
};
